// // import React, { useEffect, useRef } from "react";
// // import PropTypes from "prop-types";
// // import 'ol/ol.css';
// // import Map from 'ol/Map';
// // import View from 'ol/View';
// // import TileLayer from 'ol/layer/Tile';
// // import OSM from 'ol/source/OSM';
// // import Overlay from 'ol/Overlay';
// // import { Box, Paper, IconButton } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import RemoveIcon from "@mui/icons-material/Remove";
// // import { Vector as VectorLayer } from 'ol/layer';
// // import { Vector as VectorSource } from 'ol/source';
// // import { Feature } from 'ol';
// // import { LineString, Point } from 'ol/geom';
// // import { Style, Stroke, Circle, Fill, Text } from 'ol/style';
// // import { fromLonLat } from 'ol/proj';
// // import polyline from '@mapbox/polyline';

// // export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
// //   const mapRef = useRef(null);
// //   const overlayRef = useRef(null);
// //   const mapInstanceRef = useRef(null);
// //   const vectorLayerRef = useRef(null);

// //   // Define an array of colors for different journeys
// //   const journeyColors = [
// //     '#FF0000', // Red
// //     '#00FF00', // Green
// //     '#0000FF', // Blue
// //     '#FFA500', // Orange
// //     '#800080', // Purple
// //     '#008000', // Dark Green
// //   ];

// //   useEffect(() => {
// //     if (!mapRef.current) return;

// //     // Initialize map
// //     const tileLayer = new TileLayer({
// //       source: new OSM(),
// //     });

// //     const overlayEl = document.createElement('div');
// //     overlayEl.className = 'bg-white p-2 rounded shadow text-xs';
// //     overlayEl.style.minWidth = '120px';
// //     overlayEl.style.pointerEvents = 'none';
// //     overlayEl.innerText = '';

// //     overlayRef.current = new Overlay({
// //       element: overlayEl,
// //       positioning: 'bottom-center',
// //       stopEvent: false,
// //       offset: [0, -10],
// //     });

// //     const map = new Map({
// //       target: mapRef.current,
// //       layers: [tileLayer],
// //       overlays: [overlayRef.current],
// //       view: new View({
// //         center: fromLonLat(center),
// //         zoom,
// //       }),
// //       controls: [],
// //     });

// //     mapInstanceRef.current = map;

// //     // Initialize vector layer for routes and stops
// //     vectorLayerRef.current = new VectorLayer({
// //       source: new VectorSource(),
// //       style: (feature, resolution) => {
// //         const geometryType = feature.getGeometry().getType();
// //         if (geometryType === 'LineString') {
// //           const journeyId = feature.get('journeyId');
// //           const colorIndex = journeyId ? parseInt(journeyId.split('-')[0], 16) % journeyColors.length : 0;
// //           return new Style({
// //             stroke: new Stroke({
// //               color: journeyColors[colorIndex], // Unique color for each journey
// //               width: 3,
// //             }),
// //           });
// //         } else if (geometryType === 'Point') {
// //           const stopIndex = feature.get('stopIndex');
// //           return new Style({
// //             image: new Circle({
// //               radius: 10,
// //               fill: new Fill({ color: '#000000' }), // Black for stops
// //               stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
// //             }),
// //             text: new Text({
// //               text: stopIndex !== undefined ? stopIndex.toString() : '', // Number inside marker
// //               font: '12px sans-serif',
// //               fill: new Fill({ color: '#FFFFFF' }), // White text for contrast
// //               stroke: new Stroke({ color: '#000000', width: 2 }),
// //               offsetY: 0, // Center the number inside the marker
// //             }),
// //           });
// //         }
// //         return null;
// //       },
// //     });
// //     map.addLayer(vectorLayerRef.current);

// //     map.on('singleclick', (evt) => {
// //       const coord = evt.coordinate;
// //       const toLonLat = (c) => {
// //         const x = (c[0] / 20037508.34) * 180;
// //         let y = (c[1] / 20037508.34) * 180;
// //         y = (180 / Math.PI) * (2 * Math.atan(Math.exp((y * Math.PI) / 180)) - Math.PI / 2);
// //         return [Number(x.toFixed(6)), Number(y.toFixed(6))];
// //       };

// //       const [lon, lat] = toLonLat(coord);
// //       overlayRef.current.getElement().innerText = `Lon: ${lon}\nLat: ${lat}`;
// //       overlayRef.current.setPosition(coord);
// //     });

// //     const handleResize = () => map.updateSize();
// //     window.addEventListener('resize', handleResize);

// //     return () => {
// //       window.removeEventListener('resize', handleResize);
// //       map.setTarget(null);
// //     };
// //   }, [center, zoom]);

// //   // Update routes and stops when selectedJourneys change
// //   useEffect(() => {
// //     if (!mapInstanceRef.current || !vectorLayerRef.current) return;

// //     const source = vectorLayerRef.current.getSource();
// //     source.clear(); // Clear existing features

// //     // Filter selected journeys
// //     const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
// //     const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

// //     // Plot only selected journeys
// //     selectedJourneysData.forEach((journey, journeyIndex) => {
// //       // Decode polyline and add route
// //       try {
// //         const decodedCoords = polyline.decode(journey.encodedPath);
// //         const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
// //         const routeFeature = new Feature({
// //           geometry: new LineString(routeCoords),
// //           journeyId: journey.journeyId, // Store journeyId for color assignment
// //         });
// //         source.addFeature(routeFeature);
// //       } catch (error) {
// //         console.error("Error decoding polyline for journey", journey.journeyId, error);
// //       }

// //       // Add stop points as markers with numbers
// //       journey.stopPoints.forEach((stop, stopIndex) => {
// //         const { latitude, longitude } = stop.location;
// //         const stopFeature = new Feature({
// //           geometry: new Point(fromLonLat([longitude, latitude])),
// //           name: stop.locationName,
// //           stopIndex: (stopIndex + 1).toString(), // Number the stops starting from 1
// //         });
// //         source.addFeature(stopFeature);
// //       });

// //       // Update overlay with selected journey details
// //       const overlayEl = overlayRef.current.getElement();
// //       overlayEl.innerText = `Route: ${journey.journeyName} ${journey.type} (${journey.interval.startTime}-${journey.interval.endTime})\nStops:`;
// //       journey.stopPoints.forEach((stop, index) => {
// //         overlayEl.innerText += `\n${index + 1}: ${stop.locationName}`;
// //       });
// //     });

// //     // Adjust map view to fit all selected routes and stops
// //     if (selectedJourneysData.length > 0) {
// //       const extent = source.getExtent();
// //       if (!isFinite(extent[0])) return; // Skip if extent is invalid
// //       mapInstanceRef.current.getView().fit(extent, {
// //         padding: [50, 50, 50, 50],
// //         maxZoom: 15,
// //       });
// //     } else {
// //       overlayRef.current.getElement().innerText = '';
// //     }
// //   }, [journeys, selectedJourneys]);

// //   const handleZoomIn = () => {
// //     if (mapInstanceRef.current) {
// //       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
// //     }
// //   };

// //   const handleZoomOut = () => {
// //     if (mapInstanceRef.current) {
// //       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
// //     }
// //   };

// //   return (
// //     <Paper elevation={3} sx={{ position: "relative", width: "100%", height: 480, borderRadius: 2, overflow: "hidden" }}>
// //       <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />
// //       <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
// //         <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white" }}>
// //           <AddIcon />
// //         </IconButton>
// //         <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white" }}>
// //           <RemoveIcon />
// //         </IconButton>
// //       </Box>
// //     </Paper>
// //   );
// // }

// // SimpleOpenLayersMap.propTypes = {
// //   center: PropTypes.arrayOf(PropTypes.number),
// //   zoom: PropTypes.number,
// //   journeys: PropTypes.arrayOf(
// //     PropTypes.shape({
// //       journeyId: PropTypes.string,
// //       journeyName: PropTypes.string,
// //       type: PropTypes.string,
// //       interval: PropTypes.shape({
// //         startTime: PropTypes.string,
// //         endTime: PropTypes.string,
// //       }),
// //       encodedPath: PropTypes.string,
// //       stopPoints: PropTypes.arrayOf(
// //         PropTypes.shape({
// //           locationName: PropTypes.string,
// //           location: PropTypes.shape({
// //             latitude: PropTypes.number,
// //             longitude: PropTypes.number,
// //           }),
// //         })
// //       ),
// //     })
// //   ),
// //   selectedJourneys: PropTypes.object,
// // };

// // SimpleOpenLayersMap.defaultProps = {
// //   center: [74.2515, 16.7041], // Approximate center for Kolhapur, Maharashtra
// //   zoom: 10,
// //   journeys: [],
// //   selectedJourneys: {},
// // };
// import React, { useEffect, useRef } from "react";
// import PropTypes from "prop-types";
// import 'ol/ol.css';
// import Map from 'ol/Map';
// import View from 'ol/View';
// import TileLayer from 'ol/layer/Tile';
// import OSM from 'ol/source/OSM';
// import { Box, Paper, IconButton } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import { Vector as VectorLayer } from 'ol/layer';
// import { Vector as VectorSource } from 'ol/source';
// import { Feature } from 'ol';
// import { LineString, Point } from 'ol/geom';
// import { Style, Stroke, Circle, Fill, Text } from 'ol/style';
// import { fromLonLat } from 'ol/proj';
// import polyline from '@mapbox/polyline';

// export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
//   const mapRef = useRef(null);
//   const mapInstanceRef = useRef(null);
//   const vectorLayerRef = useRef(null);

//   // Define an array of colors for different journeys
//   const journeyColors = [
//     '#FF0000', // Red
//     '#00FF00', // Green
//     '#0000FF', // Blue
//     '#FFA500', // Orange
//     '#800080', // Purple
//     '#008000', // Dark Green
//   ];

//   useEffect(() => {
//     if (!mapRef.current) return;

//     // Initialize map
//     const tileLayer = new TileLayer({
//       source: new OSM(),
//     });

//     const map = new Map({
//       target: mapRef.current,
//       layers: [tileLayer],
//       view: new View({
//         center: fromLonLat(center),
//         zoom,
//       }),
//       controls: [],
//     });

//     mapInstanceRef.current = map;

//     // Initialize vector layer for routes and stops
//     vectorLayerRef.current = new VectorLayer({
//       source: new VectorSource(),
//       style: (feature, resolution) => {
//         const geometryType = feature.getGeometry().getType();
//         if (geometryType === 'LineString') {
//           const journeyId = feature.get('journeyId');
//           const colorIndex = journeyId ? parseInt(journeyId.split('-')[0], 16) % journeyColors.length : 0;
//           return new Style({
//             stroke: new Stroke({
//               color: journeyColors[colorIndex], // Unique color for each journey
//               width: 3,
//             }),
//           });
//         } else if (geometryType === 'Point') {
//           const stopIndex = feature.get('stopIndex');
//           return new Style({
//             image: new Circle({
//               radius: 10,
//               fill: new Fill({ color: '#000000' }), // Black for stops
//               stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
//             }),
//             text: new Text({
//               text: stopIndex !== undefined ? stopIndex.toString() : '', // Number inside marker
//               font: '12px sans-serif',
//               fill: new Fill({ color: '#FFFFFF' }), // White text for contrast
//               stroke: new Stroke({ color: '#000000', width: 2 }),
//               offsetY: 0, // Center the number inside the marker
//             }),
//           });
//         }
//         return null;
//       },
//     });
//     map.addLayer(vectorLayerRef.current);

//     const handleResize = () => map.updateSize();
//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       map.setTarget(null);
//     };
//   }, [center, zoom]);

//   // Update routes and stops when selectedJourneys change
//   useEffect(() => {
//     if (!mapInstanceRef.current || !vectorLayerRef.current) return;

//     const source = vectorLayerRef.current.getSource();
//     source.clear(); // Clear existing features

//     // Filter selected journeys
//     const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
//     const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

//     // Plot only selected journeys
//     selectedJourneysData.forEach((journey) => {
//       // Decode polyline and add route
//       try {
//         const decodedCoords = polyline.decode(journey.encodedPath);
//         const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
//         const routeFeature = new Feature({
//           geometry: new LineString(routeCoords),
//           journeyId: journey.journeyId, // Store journeyId for color assignment
//         });
//         source.addFeature(routeFeature);
//       } catch (error) {
//         console.error("Error decoding polyline for journey", journey.journeyId, error);
//       }

//       // Add stop points as markers with numbers
//       journey.stopPoints.forEach((stop, stopIndex) => {
//         const { latitude, longitude } = stop.location;
//         const stopFeature = new Feature({
//           geometry: new Point(fromLonLat([longitude, latitude])),
//           name: stop.locationName,
//           stopIndex: (stopIndex + 1).toString(), // Number the stops starting from 1
//         });
//         source.addFeature(stopFeature);
//       });
//     });

//     // Adjust map view to fit all selected routes and stops
//     if (selectedJourneysData.length > 0) {
//       const extent = source.getExtent();
//       if (!isFinite(extent[0])) return; // Skip if extent is invalid
//       mapInstanceRef.current.getView().fit(extent, {
//         padding: [50, 50, 50, 50],
//         maxZoom: 15,
//       });
//     }
//   }, [journeys, selectedJourneys]);

//   const handleZoomIn = () => {
//     if (mapInstanceRef.current) {
//       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
//     }
//   };

//   const handleZoomOut = () => {
//     if (mapInstanceRef.current) {
//       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
//     }
//   };

//   return (
//     <Paper elevation={3} sx={{ position: "relative", width: "100%", height: 480, borderRadius: 2, overflow: "hidden" }}>
//       <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />
//       <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
//         <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white" }}>
//           <AddIcon />
//         </IconButton>
//         <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white" }}>
//           <RemoveIcon />
//         </IconButton>
//       </Box>
//     </Paper>
//   );
// }

// SimpleOpenLayersMap.propTypes = {
//   center: PropTypes.arrayOf(PropTypes.number),
//   zoom: PropTypes.number,
//   journeys: PropTypes.arrayOf(
//     PropTypes.shape({
//       journeyId: PropTypes.string,
//       journeyName: PropTypes.string,
//       type: PropTypes.string,
//       interval: PropTypes.shape({
//         startTime: PropTypes.string,
//         endTime: PropTypes.string,
//       }),
//       encodedPath: PropTypes.string,
//       stopPoints: PropTypes.arrayOf(
//         PropTypes.shape({
//           locationName: PropTypes.string,
//           location: PropTypes.shape({
//             latitude: PropTypes.number,
//             longitude: PropTypes.number,
//           }),
//         })
//       ),
//     })
//   ),
//   selectedJourneys: PropTypes.object,
// };

// SimpleOpenLayersMap.defaultProps = {
//   center: [74.2515, 16.7041], // Approximate center for Kolhapur, Maharashtra
//   zoom: 10,
//   journeys: [],
//   selectedJourneys: {},
// };
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { Box, Paper, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { Style, Stroke, Circle, Fill, Text } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import polyline from '@mapbox/polyline';

export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const vectorLayerRef = useRef(null);

  // Define an array of colors for different journeys
  const journeyColors = [
    '#FF0000', // Red
    '#00FF00', // Green
    '#0000FF', // Blue
    '#FFA500', // Orange
    '#800080', // Purple
    '#008000', // Dark Green
  ];

  useEffect(() => {
    if (!mapRef.current) return;

    // Initialize map
    const tileLayer = new TileLayer({
      source: new OSM(),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [tileLayer],
      view: new View({
        center: fromLonLat(center),
        zoom,
      }),
      controls: [],
    });

    mapInstanceRef.current = map;

    // Initialize vector layer for routes and stops
    vectorLayerRef.current = new VectorLayer({
      source: new VectorSource(),
      style: (feature) => {
        const geometryType = feature.getGeometry().getType();
        if (geometryType === 'LineString') {
          const colorIndex = feature.get('colorIndex'); // Get the color index from the feature
          return new Style({
            stroke: new Stroke({
              color: journeyColors[colorIndex % journeyColors.length], // Use the assigned color
              width: 3,
            }),
          });
        } else if (geometryType === 'Point') {
          const stopIndex = feature.get('stopIndex');
          return new Style({
            image: new Circle({
              radius: 10,
              fill: new Fill({ color: '#000000' }), // Black for stops
              stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
            }),
            text: new Text({
              text: stopIndex !== undefined ? stopIndex.toString() : '', // Number inside marker
              font: '12px sans-serif',
              fill: new Fill({ color: '#FFFFFF' }), // White text for contrast
              stroke: new Stroke({ color: '#000000', width: 2 }),
              offsetY: 0, // Center the number inside the marker
            }),
          });
        }
        return null;
      },
    });
    map.addLayer(vectorLayerRef.current);

    const handleResize = () => map.updateSize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      map.setTarget(null);
    };
  }, [center, zoom]);

  // Update routes and stops when selectedJourneys change
  useEffect(() => {
    if (!mapInstanceRef.current || !vectorLayerRef.current) return;

    const source = vectorLayerRef.current.getSource();
    source.clear(); // Clear existing features

    // Filter selected journeys
    const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
    const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

    // Plot only selected journeys with unique colors
    selectedJourneysData.forEach((journey, index) => {
      // Decode polyline and add route
      try {
        const decodedCoords = polyline.decode(journey.encodedPath);
        const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
        const routeFeature = new Feature({
          geometry: new LineString(routeCoords),
          journeyId: journey.journeyId,
          colorIndex: index, // Assign color index based on order of selection
        });
        source.addFeature(routeFeature);
      } catch (error) {
        console.error("Error decoding polyline for journey", journey.journeyId, error);
      }

      // Add stop points as markers with numbers
      journey.stopPoints.forEach((stop, stopIndex) => {
        const { latitude, longitude } = stop.location;
        const stopFeature = new Feature({
          geometry: new Point(fromLonLat([longitude, latitude])),
          name: stop.locationName,
          stopIndex: (stopIndex + 1).toString(), // Number the stops starting from 1
        });
        source.addFeature(stopFeature);
      });
    });

    // Adjust map view to fit all selected routes and stops
    if (selectedJourneysData.length > 0) {
      const extent = source.getExtent();
      if (!isFinite(extent[0])) return; // Skip if extent is invalid
      mapInstanceRef.current.getView().fit(extent, {
        padding: [50, 50, 50, 50],
        maxZoom: 15,
      });
    }
  }, [journeys, selectedJourneys]);

  const handleZoomIn = () => {
    if (mapInstanceRef.current) {
      mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
    }
  };

  const handleZoomOut = () => {
    if (mapInstanceRef.current) {
      mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
    }
  };

  return (
    <Paper elevation={3} sx={{ position: "relative", width: "100%", height: 500, borderRadius: 2, overflow: "hidden" }}>
      <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />
      <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
        <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white" }}>
          <AddIcon />
        </IconButton>
        <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white" }}>
          <RemoveIcon />
        </IconButton>
      </Box>
    </Paper>
  );
}

SimpleOpenLayersMap.propTypes = {
  center: PropTypes.arrayOf(PropTypes.number),
  zoom: PropTypes.number,
  journeys: PropTypes.arrayOf(
    PropTypes.shape({
      journeyId: PropTypes.string,
      journeyName: PropTypes.string,
      type: PropTypes.string,
      interval: PropTypes.shape({
        startTime: PropTypes.string,
        endTime: PropTypes.string,
      }),
      encodedPath: PropTypes.string,
      stopPoints: PropTypes.arrayOf(
        PropTypes.shape({
          locationName: PropTypes.string,
          location: PropTypes.shape({
            latitude: PropTypes.number,
            longitude: PropTypes.number,
          }),
        })
      ),
    })
  ),
  selectedJourneys: PropTypes.object,
};

SimpleOpenLayersMap.defaultProps = {
  center: [74.2515, 16.7041], // Approximate center for Kolhapur, Maharashtra
  zoom: 10,
  journeys: [],
  selectedJourneys: {},
};